(function (global) {
  'use strict';

  function integer(value, fallback) {
    var parsed = Number(value);
    return Number.isInteger(parsed) ? parsed : fallback;
  }

  function parseRules(raw) {
    if (!raw) return [];
    return raw.split('~~').map(function (rule) {
      var parts = rule.split('@@');
      return {
        sourceControlId: parts[0],
        sourceValue: parts[1],
        maximum: integer(parts[2], -1)
      };
    }).filter(function (rule) {
      return rule.sourceControlId && rule.sourceValue && rule.maximum >= 1;
    });
  }

  function selectedSourceValue(group, sourceControlId) {
    var root = group.closest('[data-lt-properties-root]');
    if (!root) return '';
    var source = root.querySelector(
      '[data-lt-control][data-lt-control-id="' + sourceControlId.replace(/"/g, '\\"') + '"]'
    );
    if (!source) return '';
    var checked = source.querySelector('input[data-lt-property-input]:checked');
    if (checked) return checked.value;
    // A chip or swatch group with nothing checked has no selected value. Its
    // first input's value is DOM order, not a shopper choice, so reading it
    // would apply a rule the shopper never triggered. Only the renderers whose
    // single field carries its own value may fall back to that field.
    var renderer = source.dataset ? source.dataset.ltRenderer : '';
    if (renderer === 'choice_chips' || renderer === 'balloon_swatches') return '';
    var field = source.querySelector('[data-lt-property-input]');
    return field ? field.value : '';
  }

  function effectiveMaximum(group) {
    var maximum = integer(group.dataset.ltMax, -1);
    parseRules(group.dataset.ltLimitRules).some(function (rule) {
      if (selectedSourceValue(group, rule.sourceControlId) === rule.sourceValue) {
        maximum = rule.maximum;
        return true;
      }
      return false;
    });
    return maximum;
  }

  function checkedInputs(group) {
    return Array.prototype.slice.call(
      group.querySelectorAll('input[data-lt-property-input]:checked')
    );
  }

  function syncSerializedProperty(group) {
    var hidden = group.querySelector('input[data-lt-serialized-property]');
    if (!hidden) return;
    var values = checkedInputs(group).map(function (input) { return input.value; });
    hidden.value = values.join(', ');
    hidden.disabled = values.length === 0;
  }

  function overLimitMessage(overage, maximum) {
    return (
      'Remove ' + overage + ' color' + (overage === 1 ? '' : 's') +
      '. This design allows a maximum of ' + maximum + '.'
    );
  }

  function syncOverLimitState(group, count, maximum) {
    // Tightening the limit after colors are chosen leaves the selection over
    // the new maximum. Say so immediately through the control's own error
    // element instead of waiting for Add to cart; never uncheck the shopper's
    // colors and never steal focus.
    var control = group.closest ? group.closest('[data-lt-control]') : null;
    var properties = global.LTProductProperties;
    if (!control || !properties) return;
    var overage = maximum >= 1 ? count - maximum : 0;
    if (overage > 0) {
      if (typeof properties.markInvalid !== 'function') return;
      properties.markInvalid(control, overLimitMessage(overage, maximum));
      group.dataset.ltSwatchOverLimit = 'true';
    } else if (group.dataset.ltSwatchOverLimit) {
      delete group.dataset.ltSwatchOverLimit;
      if (typeof properties.clearInvalid === 'function') properties.clearInvalid(control);
    }
  }

  function syncInputAvailability(group) {
    var maximum = effectiveMaximum(group);
    var count = checkedInputs(group).length;
    var atLimit = maximum >= 1 && count >= maximum;
    var status = group.previousElementSibling;

    Array.prototype.forEach.call(
      group.querySelectorAll('input[data-lt-property-input]'),
      function (input) {
        if (input.type === 'checkbox') {
          input.disabled = atLimit && !input.checked;
        }
      }
    );

    syncOverLimitState(group, count, maximum);

    if (status && status.hasAttribute('data-lt-swatch-count')) {
      status.classList.toggle('is-full', atLimit);
    }
  }

  function updateStatus(group) {
    var count = checkedInputs(group).length;
    var minimum = integer(group.dataset.ltMin, 0);
    var maximum = effectiveMaximum(group);
    var status = group.previousElementSibling;
    if (!status || !status.hasAttribute('data-lt-swatch-count')) return;
    if (maximum < 1) {
      status.textContent = 'Color selection is unavailable.';
      return;
    }
    status.textContent =
      count + ' selected; choose ' +
      (minimum > 0 ? 'at least ' + minimum + ' and ' : '') +
      'no more than ' + maximum + '.';
  }

  function validate(group) {
    var count = checkedInputs(group).length;
    var minimum = integer(group.dataset.ltMin, -1);
    var maximum = effectiveMaximum(group);
    if (minimum < 0 || maximum < 1 || minimum > maximum) {
      return { valid: false, message: 'This color selection is unavailable.' };
    }
    if (count < minimum) {
      return {
        valid: false,
        message: minimum === 1 ? 'Please choose a color.' : 'Please choose at least ' + minimum + ' colors.'
      };
    }
    if (count > maximum) {
      return {
        valid: false,
        message: overLimitMessage(count - maximum, maximum)
      };
    }
    return { valid: true };
  }

  function validationHandshakeReady(group) {
    var root = group.closest('[data-lt-properties-root]');
    if (!root || root.dataset.ltPropertiesReady !== 'true') return false;
    var documentRef = group.ownerDocument;
    var formId = root.dataset.ltFormId;
    var form = documentRef && formId && documentRef.getElementById
      ? documentRef.getElementById(formId)
      : null;
    return Boolean(
      global.LTProductProperties &&
      typeof global.LTProductProperties.validate === 'function' &&
      form &&
      form.dataset.ltPropertiesDeclared === 'true' &&
      form.dataset.ltProductFormValidationReady === 'true'
    );
  }

  function enhance(group) {
    if (group.dataset.ltSwatchReady) return;
    if (!validationHandshakeReady(group)) return;

    var inputs = Array.prototype.slice.call(
      group.querySelectorAll('input[data-lt-property-input]')
    );
    var isMulti = inputs.some(function (input) { return input.type === 'checkbox'; });
    var fallback = null;
    var fallbackWrapper = null;
    var hidden = null;
    var groupListenerAdded = false;
    var rootListenerAdded = false;
    var root = group.closest('[data-lt-properties-root]');
    var onGroupChange = function () {
      syncSerializedProperty(group);
      syncInputAvailability(group);
      updateStatus(group);
    };
    var onRootChange = function () {
        Array.prototype.forEach.call(
          root.querySelectorAll('[data-lt-swatch-limit]'),
          function (candidate) {
            syncSerializedProperty(candidate);
            syncInputAvailability(candidate);
            updateStatus(candidate);
          }
        );
    };

    try {
      if (isMulti) {
        fallback = group.querySelector('[data-lt-multi-fallback-field]');
        if (!fallback) return;
        fallbackWrapper = fallback.closest('[data-lt-multi-fallback]');
        if (!fallbackWrapper) return;

        hidden = group.ownerDocument.createElement('input');
        hidden.type = 'hidden';
        hidden.name = group.dataset.ltFieldName;
        hidden.setAttribute('data-lt-serialized-property', '');
        hidden.disabled = true;
        group.appendChild(hidden);
      }

      group.ltValidate = function () { return validate(group); };
      group.addEventListener('change', onGroupChange);
      groupListenerAdded = true;

      if (root && !root.dataset.ltLimitSourceReady) {
        root.addEventListener('change', onRootChange);
        rootListenerAdded = true;
        root._ltLimitSourceHandler = onRootChange;
        root.dataset.ltLimitSourceReady = 'true';
      }

      syncSerializedProperty(group);
      syncInputAvailability(group);
      updateStatus(group);
      if (fallbackWrapper) fallbackWrapper.hidden = true;
      group.dataset.ltSwatchReady = 'true';
    } catch (error) {
      if (hidden && hidden.parentNode === group) group.removeChild(hidden);
      if (groupListenerAdded && group.removeEventListener) {
        group.removeEventListener('change', onGroupChange);
      }
      if (rootListenerAdded && root && root.removeEventListener) {
        root.removeEventListener('change', onRootChange);
        delete root._ltLimitSourceHandler;
        delete root.dataset.ltLimitSourceReady;
      }
      if (fallbackWrapper) fallbackWrapper.hidden = false;
      delete group.ltValidate;
      delete group.dataset.ltSwatchReady;
    }
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : global.document;
    if (!root) return;
    Array.prototype.forEach.call(
      root.querySelectorAll('[data-lt-swatch-limit]'),
      enhance
    );
  }

  var api = {
    effectiveMaximum: effectiveMaximum,
    enhance: enhance,
    init: init,
    parseRules: parseRules,
    validationHandshakeReady: validationHandshakeReady,
    validate: validate
  };
  global.LTSwatchLimit = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;

  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', function () { init(global.document); });
    } else {
      init(global.document);
    }
    global.document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    global.document.addEventListener('lt:product-properties-ready', function () {
      init(global.document);
    });
    global.document.addEventListener('lt:product-form-validation-ready', function () {
      init(global.document);
    });
  }
})(typeof window !== 'undefined' ? window : globalThis);
